//@flow
import React from 'react';
import { withTranslation, TFunction } from 'react-i18next';
import {
  MigrationBannerDiv,
  MigrationBannerP,
  MigrationBannerLink
} from './LayoutStyles';

type Props = {
  t: TFunction
};

function MigrationBanner({ t }: Props) {
  return (
    <MigrationBannerDiv>
      <MigrationBannerP>
        {t('migrationBanner.message')}{' '}
        <MigrationBannerLink href="mailto:rukshan.dharmadasa@getbitflow.com">
          rukshan.dharmadasa@getbitflow.com
        </MigrationBannerLink>
        .
      </MigrationBannerP>
    </MigrationBannerDiv>
  );
}

export default withTranslation(['global'])(MigrationBanner);
